import {
  WordType,
  WordExportType,
  WordTypeWithImages,
} from "../features/words/types";
import { WordImage } from "./WordService";

export interface AdminWordServiceOptions {
  fullExport?: boolean;
  limit?: number;
}

export interface WordOperationResult {
  success: boolean;
  data?: WordTypeWithImages;
  error?: string;
}

export interface ChangeAction {
  word: Partial<WordType>;
  action: "add" | "edit" | "delete";
}

export abstract class AdminWordService {
  // Core CRUD operations
  abstract addWord(word: WordTypeWithImages): Promise<WordOperationResult>;

  abstract getWord(word: string): Promise<WordOperationResult>;

  abstract updateWord(word: WordTypeWithImages): Promise<WordOperationResult>;

  abstract deleteWord(word: string): Promise<boolean>;

  abstract renameWord(
    oldWord: string,
    newWord: WordTypeWithImages
  ): Promise<WordOperationResult>;

  // Export operations
  abstract exportWords(
    options?: AdminWordServiceOptions
  ): Promise<WordExportType[]>;

  // Change tracking operations
  abstract addChange(change: ChangeAction): Promise<void>;

  // Image search for admin features
  abstract searchImages(keyword: string, limit?: number): Promise<WordImage[]>;
}
